import { render, staticRenderFns } from "./InventoryValueTables.vue?vue&type=template&id=47e033f3"
import script from "./InventoryValueTables.vue?vue&type=script&lang=js"
export * from "./InventoryValueTables.vue?vue&type=script&lang=js"
import style0 from "./InventoryValueTables.vue?vue&type=style&index=0&id=47e033f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports